import { render, staticRenderFns } from "./VisibleColumns.vue?vue&type=template&id=640bcd77&scoped=true"
import script from "./VisibleColumns.vue?vue&type=script&lang=js"
export * from "./VisibleColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bcd77",
  null
  
)

export default component.exports